interface IPollTextarea {
  handleTextResponseChange: any;
  questionNum: number;
  responses: any;
}

const PollTextarea = ({ handleTextResponseChange, questionNum, responses }: IPollTextarea) => {
  return (
    <textarea
      aria-label="Type your answer ."
      className="w-full resize-none p-[15px] focus:p-[14px] rounded-lg overflow-hidden break-words text-start focus:outline-red-main focus:shadow-none focus:outline-0 focus:border-2 leading-5 focus:border-red-main border-black border-opacity-10 hover:border-opacity-25"
      style={{ boxShadow: 'none' }}
      name="text"
      placeholder="Type your answer ..."
      rows={5}
      value={responses[questionNum] ? responses[questionNum] : ''}
      onChange={(e) => handleTextResponseChange(questionNum, e.target.value)}
    ></textarea>
  );
};

export default PollTextarea;
